import React from 'react';
import { createRoot } from 'react-dom/client';
import './app/globals.scss';
import App from './app/app';

const root = createRoot(document.getElementById('root')!);
root.render(<App />);
